/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable spaced-comment */
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import HeaderInformativo from './components/HeaderInformativo';
import Footer from './components/Footer';
import Contacto from './pages/Contacto';
import Productos from './pages/Productos';
import Producto from './components/productos/InformacionProducto';
import Inicio from './pages/Inicio';
import Nosotros from './pages/Nosotros';
import Cotizaciones from './pages/Cotizaciones';
import WhatsAppButton from './components/WhatsAppButton';
import Soluciones from './pages/Soluciones';

function App() {
  return (
    <>
{/* Google Tag Manager */}
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-TDDHKX23WL"
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-TDDHKX23WL');
          `,
        }}
      />
      {/* End Google Tag Manager */}
      <Router>
      <HeaderInformativo />
      <Header />
      <WhatsAppButton />
      <Routes>
        <Route path="/contacto" element={<Contacto />} />
        <Route path="/productos/:categoria?" element={<Productos />} />
        <Route path="/producto/:titulo" element={<Producto />} />
        <Route path="/nosotros" element={<Nosotros />} />
        <Route path="/cotizaciones" element={<Cotizaciones />} />
        <Route path="/soluciones/:tab?" element={<Soluciones />} />
        <Route path="/" element={<Inicio />} />
      </Routes>
      <Footer />
    </Router>
    </>
  );
}

export default App;
